(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('EditorStructurePartSettingsController', EditorStructurePartSettingsController);

    EditorStructurePartSettingsController.$inject = ['$scope', '$uibModalInstance', 'part'];

    function EditorStructurePartSettingsController($scope, $uibModalInstance, part) {
        var vm = this;

        vm.size = part.physicalSize;

        // TODO: 选项为占位数据，材料/工艺接口落地后替换为接口数据
        vm.materials = ['透明板3.5mm', '透明板5mm', '亚克力3mm', '亚克力5mm'];
        vm.printingMethods = ['6色高清UV', '4色高清UV', '丝网印刷'];
        vm.stampingMethods = ['烫金', '烫银', '无'];
        vm.cuttingMethods = ['激光裁切', '刀模裁切', '无'];

        vm.settings = {
            material: part.material || '',
            printing: part.printingMethod || '',
            stamping: part.stampingMethod || '',
            cutting: part.cuttingMethod || ''
        };

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.confirm = function () {
            $uibModalInstance.close(angular.copy(vm.settings));
        };
    }
})();
